import axios from 'axios';

import { getBaseUrl } from 'utils/url';
import headers from 'common/headers';

declare module 'axios' {
  export interface AxiosRequestConfig {
    skipServerErrorModal?: boolean;
    // resolve with the whole response body (not just its result), for callers that read errorFound / errorMessages
    returnResponseBody?: boolean;
  }
}

export interface APIResponseSchema {
  errorCode: number | null;
  errorFound: boolean;
  errorMessage: string | null;
}

export interface APIResponseIdSchema extends APIResponseSchema {
  id: number;
}

export interface APIResponseItemSchema<Type> extends APIResponseSchema {
  result: Type | null;
}

export interface APIResponseArraySchema<Type> extends APIResponseSchema {
  result: Type[] | null;
}

const api = axios.create({
  headers,
  baseURL: getBaseUrl(),
  // sends the HttpOnly OTP session cookie; the API is same-site, so SameSite=Strict still applies
  withCredentials: true,
});

export default api;
